export interface AnyType {
  [key: string]: any;
}

export enum EnumMethod {
  Post = "post",
  Get = "get",
  Delete = "delete",
}
